// node_modules
import { FC, useContext} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { 
    useHistory,
    useRouteMatch
} from "react-router-dom";
// styles
import styles from "./sidebarMenuItem.module.scss";
import menuStyles from "./sidebarMenu.module.scss";
// Contexts
import { CaseContext } from "Stores";

type TSidebarMenuItemProps = {
    icon: IconDefinition;
    text: string;
    isActive?: boolean;
    isResults?: boolean;
    onClickHandler?: () => void;
    extraContent: JSX.Element | JSX.Element[];
    extraClassName: string;
};

export const SidebarMenuItem: FC<TSidebarMenuItemProps> = ({icon, text, isActive, isResults, onClickHandler, extraContent, extraClassName}: TSidebarMenuItemProps) => {
    // `url` lets
    // us build relative links.
    const { url } = useRouteMatch();

    // Contexts
    const { caseState } = useContext(CaseContext);

    // We get history to navigate
    const history = useHistory();

    const handleClickOnSidebarMenuItem = (): void => {
        let newHistory = `${url}/${text.toLowerCase()}`;

        // if a case phase is selected and its a click on the Results menu item
        // we append the case phase at the end of the new history
        // to display the correct phase component
        if (isResults && caseState.casePhase) {
            if(caseState.selectedCase?.isPhaseOnePublished || caseState.selectedCase?.isPhaseTwoPublished) {
                newHistory += `/${caseState.casePhase.toLowerCase()}`;
            }
        }
        
        // we change the history to display the related component
        history.replace(newHistory);

        if(onClickHandler) onClickHandler();
    };

    const getMainClassName = (): string => {
        const classNameList = [menuStyles.sidebarMenuItem, styles.sidebarMenuItem];
        if(isActive) classNameList.push(styles.active);
        if(isResults) classNameList.push(styles.resultsSection);
        return classNameList.join(" ");
    };

    return (
        <div className={extraClassName ? extraClassName : ""} style={{overflow: "hidden", minHeight: "2.5rem"}}>
            <div className={getMainClassName()} onClick={handleClickOnSidebarMenuItem}>
                <div className={styles.sidebarMenuIconContainer}>
                    <FontAwesomeIcon icon={icon} className={styles.sidebarMenuItemIcon} />
                </div>
                <h5>
                    {text}
                </h5>
            </div>
            {isActive && extraContent ? 
                extraContent 
                : <></>}
        </div>
    );
};
